<template>
  <g id="zombie">
    <path
      class="cls-22"
      d="M1480.5 995.1v24.9h-316.6v-24.9a121.1 121.1 0 0174.5-111.7 130.5 130.5 0 0119.5-6.3l2-.4a117.9 117.9 0 0126.1-2.8h73a117.4 117.4 0 0127.4 3.1l1.9.4a121.2 121.2 0 0192.2 117.7z"
      transform="translate(17)"
    />
    <path
      class="cls-23"
      d="M1405.9 883.2v23.5a83.8 83.8 0 11-167.5 0v-23.3a130.5 130.5 0 0119.5-6.3l2-.4a117.9 117.9 0 0126.1-2.8h73a117.4 117.4 0 0127.4 3.1l1.9.4a120.8 120.8 0 0117.6 5.8z"
      transform="translate(17)"
    />
    <path
      class="cls-24"
      d="M1386.4 877v29.7a64.3 64.3 0 11-128.5 0v-29.6l2-.4a117.9 117.9 0 0126.1-2.8h73.1a117.2 117.2 0 0127.3 3.1z"
      transform="translate(17)"
    />
    <path
      class="cls-24"
      d="M1312.4 1000.6v-48.3h17.1v48.3a8.5 8.5 0 01-8.5 8.5 8.6 8.6 0 01-8.6-8.5zM1344.1 982.5v-41.8h17v41.8a8.5 8.5 0 01-8.5 8.5 8.5 8.5 0 01-8.5-8.5z"
      transform="translate(17)"
    />
    <path
      class="cls-25"
      d="M1290.5 843.3h97.4v48.5a48.3 48.3 0 01-48.3 48.3h-.4a48.7 48.7 0 01-48.7-48.7v-48.1z"
    />
    <path
      class="cls-26"
      d="M1501.8 794.9v52.4h-324.1v-33.7l-17.6 33.7h-17.5v-52.4c0-99.2 80.5-179.6 179.6-179.6a179.6 179.6 0 01179.6 179.6z"
      transform="translate(17)"
    />
    <path
      class="cls-27"
      d="M1322.2 875.7a109.7 109.7 0 01-109.6-109.6v-93.3c0-60.5 49.3-109.6 109.8-109.6a109.6 109.6 0 01109.4 109.6v93.3a109.7 109.7 0 01-109.6 109.6z"
      transform="translate(17)"
    />
    <path
      class="cls-24"
      d="M1200.6 715.7h87.5v63.4h-87.5a32 32 0 01-31.7-32v.2a31.6 31.6 0 0131.7-31.6zM1476.1 747.1a30.8 30.8 0 01-1 8 7.4 7.4 0 00-4.4-1.3 8.2 8.2 0 00-8.2 8.2 8.4 8.4 0 004.6 7.4 31.8 31.8 0 01-22.7 9.7h-88.1v-63.4h88.1a31.5 31.5 0 0131.7 31.4z"
      transform="translate(17)"
    />
    <path
      class="cls-28"
      d="M1443.9 672.8v93.3c0 4.4-.2 8.7-.6 13a121.8 121.8 0 01-72.4 98.6c-2.1 1-4.3 1.8-6.4 2.6a121.5 121.5 0 01-84.6 0c-2.2-.8-4.3-1.6-6.4-2.6a121.6 121.6 0 01-72.4-98.6 112 112 0 01-.7-13v-93.3c0-6.8.9-13.1 2-20.4h34.2c19.8 0 38.2-9.7 48.6-25.9 18-3.5 32.1-19.2 32.1-38.2v-37.1c0-.2 3.6-.2 5.7-.2a120.4 120.4 0 0185.7 35.7c22 22 35.2 52.4 35.2 86.1z"
      transform="translate(17)"
    />
    <path
      class="cls-18"
      d="M1278 716.9a14.7 14.7 0 11-14.6-14.6 14.6 14.6 0 0114.6 14.6z"
      transform="translate(17)"
    />
    <circle class="cls-29" cx="1408.2" cy="715.1" r="39.8" />
    <circle class="cls-18" cx="1395.7" cy="733.8" r="7.8" />
    <path
      class="cls-24"
      d="M1299.4 715.7c0 19.5-16.2 36.1-36 36.1a36.4 36.4 0 01-36.1-36.1z"
      transform="translate(17)"
    />
    <path
      class="cls-30"
      d="M1306.5 873.9a6.3 6.3 0 01-6.2-6.3v-35h12.1V868a5.9 5.9 0 01-5.9 5.9zM1317.3 551.2v37.1c0 19-14.1 34.7-32.1 38.2-10.4 16.2-28.8 25.9-48.6 25.9h-34.2l16.8-17h17.4c17 0 31.5-9.8 37.5-24.4h3.1c12.3 0 23.1-10.5 23.1-22.7v-22.9z"
      transform="translate(17)"
    />
    <path
      class="cls-24"
      d="M1403.4 766.9h-52v-28.4h80.4a28.4 28.4 0 01-28.4 28.4z"
      transform="translate(17)"
    />
    <path class="cls-24" d="M1329.4 786.4h19.5v34.09h-19.5z" />
    <path
      class="cls-30"
      d="M1344.1 834.6v74.3a7.6 7.6 0 01-7.3 7.9c-4.3-.1-7.3-3.6-7.3-7.9v-74.3z"
      transform="translate(17)"
    />
    <path
      class="cls-30"
      d="M1344.1 847.2v8.4a25.5 25.5 0 01-13.4 3.8h-18.3a25 25 0 01-12.1-3.8v-8.4z"
      transform="translate(17)"
    />
    <path
      class="cls-18"
      d="M1344.1 833.9a13.4 13.4 0 01-13.4 13.3h-17a13.4 13.4 0 01-13.4-13.3 13.4 13.4 0 0113.4-13.4h17a13.4 13.4 0 0113.4 13.4z"
      transform="translate(17)"
    />
    <path
      class="cls-24"
      d="M1273.5 851.4v26.3a121.6 121.6 0 01-72.4-98.6 72.4 72.4 0 0172.4 72.3zM1443.3 779.1a121.8 121.8 0 01-72.4 98.6v-26.3a72.4 72.4 0 0172.4-72.3z"
      transform="translate(17)"
    />
    <path class="cls-18" d="M1329.4 738.5h19.5v28.35h-19.5z" />
  </g>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>